var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 200,
    viewBox: "0 0 241 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2509_11818)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 200,
    transform: "translate(0.5)",
    fill: "url(#paint0_linear_2509_11818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75 172.75L190.25 150.25M197.75 131.5C197.75 134.947 197.071 138.361 195.752 141.545C194.433 144.73 192.499 147.624 190.062 150.062C187.624 152.499 184.73 154.433 181.545 155.752C178.361 157.071 174.947 157.75 171.5 157.75C168.053 157.75 164.639 157.071 161.455 155.752C158.27 154.433 155.376 152.499 152.938 150.062C150.501 147.624 148.567 144.73 147.248 141.545C145.929 138.361 145.25 134.947 145.25 131.5C145.25 124.538 148.016 117.861 152.938 112.938C157.861 108.016 164.538 105.25 171.5 105.25C178.462 105.25 185.139 108.016 190.062 112.938C194.984 117.861 197.75 124.538 197.75 131.5Z",
    stroke: "#DEA7FF",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 133,
    height: 16,
    rx: 8,
    fill: "#F5E4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 48,
    width: 133,
    height: 12,
    rx: 6,
    fill: "#F5E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 36C169 29.3726 174.373 24 181 24H212C218.627 24 224 29.3726 224 36C224 42.6274 218.627 48 212 48H181C174.373 48 169 42.6274 169 36Z",
    fill: "#F5E4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2509_11818",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.516819,
    stopColor: "#FBF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2509_11818"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 240,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState1);
export default __webpack_public_path__ + "static/media/empty_state_1.c4f3af8553bb754c23ad4abf0a1d564b.svg";
export { ForwardRef as ReactComponent };